import { BlockedRecordDetailsProvider } from '@exam-center/blocked-record-details';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { useParams } from '@exam-center/router';
import { PermissionGuard } from '@shared/permissions';

export default function BlockedRecordDetailsLayout() {
  const { blockedUserId, blockedRecordId } = useParams(
    '/admin/blocklist/:blockedUserId/:blockedRecordId',
  );

  return (
    <PermissionGuard
      requiredPermission={APP_PERMISSIONS.ADMIN_BLOCKLIST_MANAGEMENT.BLOCKED_USER.VIEW}
    >
      <BlockedRecordDetailsProvider
        blockedUserId={blockedUserId}
        blockedRecordId={blockedRecordId}
      />
    </PermissionGuard>
  );
}
